export const AppPermissions = {
  // Main permissions
  PortalAccess: ['TMBAP.PortalAccess@TMBAP'],
};
